import React, { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import { API_URL } from "../../constant/API_Settings";
import { logoutSignedInElsewhere } from "../../utils/sessionLogout";

/**
 * Background poll (30s) of auth/check-force-logout while AUTH_TOKEN exists.
 * Handles approval lockout (force_logout), maintenance mode, and a revoked
 * bearer token (another login with the same credentials).
 */
const ForceLogoutPoller = ({ onMaintenance }) => {
	const history = useHistory();
	const pollRef = useRef(null);
	const handledRef = useRef(false);

	useEffect(() => {
		handledRef.current = false;

		const poll = () => {
			const token = localStorage.getItem("AUTH_TOKEN");
			if (!token || handledRef.current) return;

			const requestOptions = {
				method: "get",
				headers: {
					Authorization: "Bearer " + token,
					Accept: "application/json",
				},
			};

			fetch(API_URL + "/auth/check-force-logout", requestOptions)
				.then((response) => response.json().then((data) => ({ ok: response.ok, status: response.status, data })))
				.then(({ ok, status, data }) => {
					if (handledRef.current) return;

					if (
						data &&
						(data.maintenance === true ||
							data.maintenance === 1 ||
							data.maintenance === "1" ||
							data.code === "MAINTENANCE" ||
							status === 503)
					) {
						handledRef.current = true;
						if (pollRef.current) {
							clearInterval(pollRef.current);
							pollRef.current = null;
						}
						const message =
							data.maintenance_message ||
							data.message ||
							"System is under maintenance. Please try again later.";
						if (typeof onMaintenance === "function") {
							onMaintenance(message);
						} else {
							localStorage.removeItem("AUTH_TOKEN");
							swal("", message, "info").then(() => {
								history.push("/login");
							});
						}
						return;
					}

					if (
						data &&
						(data.force_logout === true ||
							data.force_logout === 1 ||
							data.force_logout === "1")
					) {
						handledRef.current = true;
						if (pollRef.current) {
							clearInterval(pollRef.current);
							pollRef.current = null;
						}
						swal(
							"",
							"Approval process is started, please wait some time",
							"info"
						).then(() => {
							localStorage.removeItem("AUTH_TOKEN");
							history.push("/login");
						});
					}

					if (!ok && status === 401) {
						handledRef.current = true;
						if (pollRef.current) {
							clearInterval(pollRef.current);
							pollRef.current = null;
						}
						logoutSignedInElsewhere(history);
					}
				})
				.catch(() => {});
		};

		poll();
		pollRef.current = setInterval(poll, 30000);

		return () => {
			if (pollRef.current) {
				clearInterval(pollRef.current);
				pollRef.current = null;
			}
		};
	}, [history, onMaintenance]);

	return null;
};

export default ForceLogoutPoller;
